import React from "react";

function Input({
  label, // The text to be displayed as the label for the input field.
  id, // The `id` of the input field, used for linking the label with the input element.
  isRequired = true,
  placeholder = "", // Placeholder for the container
  containerStyle = "", // Custom CSS classes to be applied to the container of the input field.
  labelStyle = "", // Custom CSS classes to be applied to the label of the input field.
  inputStyle = "", // Custom CSS classes to be applied to the input element.
  ...props // Spread operator to include any additional props passed to the input element (e.g., `name`, `type`, `value`, etc.).
}) {
  return (
    <div className={`w-full ${containerStyle} `}>
      {label && (
        <label
          htmlFor={id}
          className={`form-label block font-inter text-secondary text-level-3 font-medium leading-[24px]  ${labelStyle} `}
        >
          {label} {isRequired && <span className="text-light-red">*</span>}
        </label>
      )}
      <input
        {...props}
        id={id}
        placeholder={placeholder}
        className={`mt-[12px] px-[12px] font-inter py-[15px] h-[48px] block rounded-[5px] text-gray text-[15px] border-[1.5px] border-medium-gray  focus:border-blue-shades focus:outline-none ${inputStyle}`}
      />
    </div>
  );
}

export default Input;
